module.exports = __webpack_public_path__ + "img/1579.0e55ce70.jpg";